module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "profile-v1.3ab122e6.png" + "?" + Date.now();